module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-122.933f0dda.svg";